// extracted by mini-css-extract-plugin
export default {"container":"CreateSkin_container__nbwio","fieldset":"CreateSkin_fieldset__MPnyd"};